import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import useExistingNumberForm from 'hooks/useExistingNumberDrawer';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const ContactField = ({
    isRequired = true,
    state,
    onChange,
    stateError,
    walkthroughId,
    darkMode,
    label,
    field,
    tooltipLabel,
    touched,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { NUMBER_ONLY, FIELD_REQUIRED } = useExistingNumberForm({});
    const numberField = field?.toLowerCase().includes('number');
    const isTouchedButEmpty = !state?.[field] && touched?.[field];
    const isNaNTest = touched?.[field] && numberField && isNaN(state?.[field]);

    const isInvalid =
        // is empty
        isTouchedButEmpty ||
        // invalid value for number
        isNaNTest ||
        // has value but is error
        (state?.[field] && stateError?.[field]);
    const errorMessage = isTouchedButEmpty
        ? FIELD_REQUIRED
        : isNaNTest
          ? NUMBER_ONLY
          : stateError?.[field];

    return (
        <FormControl
            isRequired={isRequired}
            sx={{ margin: '0 !important' }}
            isInvalid={isInvalid}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            data-cy={`input-${field}`}>
            <Stack direction="row" sx={stackStyling()}>
                <Box width={190}>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                            minW: '190px',
                            overflowWrap: 'break-word',
                            whiteSpace: 'normal',
                            paddingY: '15px',
                        }}>
                        {label}
                    </FormLabel>
                </Box>
                <Field
                    component={NameField}
                    width={520}
                    id={field}
                    name={field}
                    value={state?.[field]}
                    onChange={onChange}
                    walkthroughid={walkthroughId}
                />
                {isHovered && (
                    <FieldToolTip
                        label={tooltipLabel}
                        ariaLabel={`${tooltipLabel}-tip`}
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
            <FieldError>{errorMessage}</FieldError>
        </FormControl>
    );
};

export default ContactField;
